import { render } from "./form5page.vue?vue&type=template&id=155106a4&scoped=true"
import script from "./form5page.vue?vue&type=script&lang=js"
export * from "./form5page.vue?vue&type=script&lang=js"

import "./form5page.vue?vue&type=style&index=0&id=155106a4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155106a4"]])

export default __exports__